import { useMutation } from '@tanstack/react-query';
import { submitFeedback, CreateFeedbackPayload } from '../feedbackApi';

export function useSubmitFeedback() {
  return useMutation({
    mutationFn: (payload: CreateFeedbackPayload) => submitFeedback(payload),
  });
}
